var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password"},[_c('input',{attrs:{"type":"number"},on:{"input":_vm.inputPassword}}),_vm._l((6),function(index){return _c('span',{key:index},[_vm._v(_vm._s(_vm.value?.length >= index ? '●' : ''))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }